import React, { useContext } from 'react';
import {
  UserAvatar,
  ChevronRight,
  Notification,
  Review,
  Wallet
} from '@carbon/icons-react';
import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useTheme,
  useMediaQuery,
  IconButton
} from '@material-ui/core';
import { clsx, colorSet } from '@components/Provider';
import { CustomizedButton } from '@components/Customized';
import { MyAccountContext } from '../../MyAccountContainer';
import { useStyles } from './styles';
import { useHistory } from 'react-router-dom';

interface MenuListProps {
  onChangeCurrentTab: (_: number) => void;
  handleLogout: () => void;
  onUpload: (data: Array<File>) => Promise<void>;
  onUpdateProfileImage: (_: any) => void;
  open: boolean;
}

const Tabs = [
  {
    label: '계정설정',
    tab: 'profile',
    Icon: UserAvatar
  },
  {
    label: '계좌관리',
    tab: 'backAccount',
    Icon: Wallet
  },
  {
    label: '알림설정',
    tab: 'notification',
    Icon: Notification
  },
  {
    label: '리뷰관리',
    tab: 'review',
    Icon: Review
  }
] as const;

type Tab = typeof Tabs[number]['tab'];

export default (props: MenuListProps) => {
  const context = useContext(MyAccountContext);
  const classes = useStyles();
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));
  const history = useHistory();

  const handleChangeTab = (tab: Tab) => {
    history.push(`/mypage/${tab}`);
  };

  const RenderingTab = matches ? Tabs.slice(1) : Tabs;

  return (
    <Grid container>
      <List
        component="nav"
        className={classes.listRoot}
        aria-labelledby="nested-list-subheader"
      >
        {RenderingTab.map(({ label, tab, Icon }) => {
          const isActive = context.current === tab;

          return (
            <ListItem
              key={label}
              button
              onClick={() => handleChangeTab(tab)}
              className={clsx(classes.listItem, { 'active': isActive })}
            >
              <ListItemIcon
                className={clsx(classes.listIcon, { 'active': isActive })}
              >
                <Icon size={20} color={colorSet.gray900} />
              </ListItemIcon>
              <ListItemText
                primary={label}
                primaryTypographyProps={{
                  className: clsx(classes.listItemText, { 'active': isActive })
                }}
              />
              {matches && (
                <IconButton>
                  <ChevronRight size={20} color={colorSet.gray600} />
                </IconButton>
              )}
            </ListItem>
          );
        })}
      </List>
      <CustomizedButton
        variant="text"
        color="default"
        onClick={props.handleLogout}
        className={classes.logoutButton}
      >
        로그아웃
      </CustomizedButton>
    </Grid>
  );
};
